import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { sendCapiPageView } from '../../utils/capiPageView'

// STY-394: fires one CAPI PageView per route (initial load + every SPA
// navigation) once the logged-in vendor is resolved. Renders nothing.
//
// react-router-dom v5.1 useLocation() updates on every client navigation;
// keying the effect on pathname+search gives exactly one PageView per view.
// A lastKey ref guards against double-fires (e.g. user resolving after the
// first location render, or identical re-renders).
export default function PageViewTracker ({ user }) {
  const location = useLocation()
  const lastKey = useRef('')

  useEffect(() => {
    if (!user || !user.email) return
    const key = location.pathname + location.search
    if (key === lastKey.current) return
    lastKey.current = key
    sendCapiPageView(user)
  }, [location.pathname, location.search, user])

  return null
}
